import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { MyStore, reducers } from 'kts-platform-frame/redux';
import { create } from 'kts-scaffold-framework/utils/form';
import { Button, Drawer, Form, Checkbox } from 'kts-xui';
import { FormInstance } from 'kts-components-antd-x4/lib/form';
import { Tag, Space } from 'kts-components-antd-x4';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Urls } from 'kts-platform-frame/entry/constant';
import { invite } from 'src/api';
import { serverDomain } from 'kts-platform-frame/entry/configUtils';
const css = require('./index.scss');
const { CheckableTag } = Tag;
const FormItem = Form.Item;
/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    onClose?: () => void;
}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {
    formRef = React.createRef<FormInstance>();
    // tagsData = ['发票协同', '对账协同'];
    // tagsData2 = ['发票协同', '对账协同'];
    constructor(props: IProps) {
        super(props, ModulesAction);
        this.state = {
            publicLinkTicket: '',
            selectedTags: [],
            purchaserTag: [],
            supplierTag: [],
            radioVal: ['SUPPLIER']
        };
    }
    componentDidMount() {
        this.getCategories();
    }
    getCategories = async () => {
        const res:any = await invite.getCategory(this, {
            bizRoles: 'PURCHASER',
        });
        
        if (!res.er && res.res) {
            res.res = res.res.map((item, index) => {
                return {
                    ...item,
                    key: index
                };
            });
            this.setState({
                purchaserTag: res.res,
            });
        }
        const res2:any = await invite.getCategory(this, {
            bizRoles: 'SUPPLIER',
        });
        
        if (!res2.er && res2.res) {
            res2.res = res2.res.map((item, index) => {
                return {
                    ...item,
                    key: index + (res.res.length || 0)
                };
            });
            this.setState({
                supplierTag: res2.res,
                selectedTags: res2.res
            });
        }
    }
    createLink = async () => {
        this.formRef.current!.submit();

    }
    onClose = () => {
        this.props.onClose();
    }
    onRadioChange = (list) => {
        let tags=[];
        tags=list.includes('SUPPLIER')&&tags.concat(this.state.supplierTag)||tags;
        tags=list.includes('PURCHASER')&&tags.concat(this.state.purchaserTag)||tags;
        console.log(tags);
        this.setState({
            radioVal: list,
            selectedTags: tags
        });
    }
    handleChange(tag: any, checked: boolean) {
        const { selectedTags,purchaserTag ,supplierTag,radioVal} = this.state;
        const nextSelectedTags = checked ? [...selectedTags, tag] : selectedTags.filter(t => t.key !== tag.key);
        let strArray=[];
       
        const purchaserTagIds=purchaserTag.reduce((a,b)=>{
             a.push(b.key);
             return a;
        },[]);
        const supplierTagIds=supplierTag.reduce((a,b)=>{
            a.push(b.key);
            return a;
       },[]);
       nextSelectedTags.forEach((item)=>{
            if(supplierTagIds.includes(item.key)){
                if(!strArray.includes('SUPPLIER')){
                    strArray=strArray.concat(['SUPPLIER']);
                }
                
            }else{
                if(purchaserTagIds.includes(item.key)){
                    if(!strArray.includes('PURCHASER')){
                        strArray=strArray.concat(['PURCHASER']);
                    }
                }
            }
        },[]);
        this.setState({ 
            selectedTags: nextSelectedTags,
            radioVal:strArray
         });
         this.formRef.current.setFieldsValue({bizRoles:strArray});
    }
    submitModal = async (values) => {
        const res = await invite.inviteOpen(this, {
            categories: this.state.selectedTags,
            expiredDay: 31,
            ...values
        });
        if (!res.er && res.res) {
            this.setState({
                publicLinkTicket: res.res.ticket
            });
        }
    }
    render() {
        const { user, } = MyStore.instance.getState();
        const { radioVal, selectedTags, publicLinkTicket } = this.state;
        const props = {
            action: serverDomain() + Urls.inviteBatchNetworkCompany,
            headers: {
                Authorization: user.cToken,
                zoneUrl: serverDomain()
            }
        };
        const url = kts.Env.instance().workingUrl('tmgp.siemens.com.cn/login');
        const publicLinks = url + '/register.html?ticket=' + this.state.publicLinkTicket;
        return (
            <div className={`uploadbatchtext asideroverall`}>
                <Drawer
                    title="邀请链接"
                    onClose={this.onClose}
                    visible={true}

                >
                    <Form
                        layout='vertical'
                        ref={this.formRef}
                        labelCol={null}
                        wrapperCol={null}
                        onFinish={this.submitModal}
                    >
                        <FormItem
                            label='业务角色'
                            name='bizRoles'
                            rules={[{ required: true, message: "请勾选业务角色", }]}
                            initialValue={radioVal}
                            className='sm-radio'
                        >
                            <Checkbox.Group onChange={this.onRadioChange}>
                                <Space direction="vertical">
                                    <Checkbox value='SUPPLIER'>我的供应商
                                    </Checkbox>
                                    <div>
                                        {this.state.supplierTag.map(tag => (
                                            <CheckableTag
                                                key={tag.key}
                                                checked={selectedTags.findIndex(item => item.key === tag.key) >= 0 ? true : false}
                                                onChange={checked => this.handleChange(tag, checked)}
                                            >
                                                {tag.categoryName}
                                            </CheckableTag>
                                        ))}
                                    </div>
                                    <Checkbox value='PURCHASER'>我的客户/经销商
                                    </Checkbox>
                                    <div>
                                        {this.state.purchaserTag.map(tag => (
                                            <CheckableTag
                                                key={tag.key}
                                                checked={selectedTags.findIndex(item => item.key === tag.key) >= 0 ? true : false}
                                                onChange={checked => this.handleChange(tag, checked)}
                                            >
                                                {tag.categoryName}
                                            </CheckableTag>
                                        ))}
                                    </div>

                                </Space>
                            </Checkbox.Group>
                        </FormItem>
                    </Form>
                    <Button type='link' onClick={this.createLink}>生成链接</Button>
                    {publicLinkTicket &&
                        <div className={css.publicLinks}>
                            <div className={css.header}>
                                您公司的公共邀请链接为：
                        </div>
                            <div className={css.links}>{publicLinks}</div>
                            <div className={css.tips}>该链接的有效期为 31 天，失效后需重新生成。</div>
                            <div className={css.btn}>
                                <Button type="default" onClick={this.preview}>预览</Button>
                                <CopyToClipboard
                                    text={publicLinks}
                                >
                                    <Button className="ml-10 kts-but-primary">复制链接</Button>
                                </CopyToClipboard>
                            </div>
                        </div>
                    }
                </Drawer>
            </div>
        );
    }
    preview = () => {
        // const url = kts.Env.instance().workingUrl('//login{env}kingxunlian.com');
        const url = kts.Env.instance().workingUrl('//tmgp.siemens.com.cn/login');
        const publicLinks = url + '/register.html?ticket=' + this.state.publicLinkTicket;
        window.location.href = publicLinks;
        // if(this.modulesState.publicLinkTicket){
        //     history.push('/network/PublicCompanyRegister?ticket='+this.modulesState.publicLinkTicket);
        // }
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/Network/UI.Network.Modal.Link.tsx